import React, {useState} from 'react';
import Alert from 'react-bootstrap/Alert';
import {useIntl} from 'react-intl';

import ManualPromotedTable from './ManualPromotedTable';
import ComputedPromotedTable from './ComputedPromotedTable';

/**
 * Pestaña "Promovidos": las tablas Manuales y Computados, cada una con su
 * endpoint, su barra de filtros, su loader y su refresco. Aquí solo vive el
 * aviso de motor apagado, que se toma de la respuesta de Manuales.
 */
function PromotedTable({onSelectEvent}) {
    const intl = useIntl();
    const [meta, setMeta] = useState(null);
    // Derivado en render, no guardado en estado (rerender-derived-state-no-effect).
    const effectiveApplyEnabled =
        meta !== null &&
        Boolean(meta.applyEnabled) &&
        meta.featuredCategoryId !== null &&
        meta.featuredCategoryId !== undefined;

    return (
        <div data-test='promotedTableComponent' className='mt-2'>
            {meta !== null && !effectiveApplyEnabled && (
                <Alert
                    variant='warning'
                    data-test='promotedApplyDisabledWarning'
                >
                    {intl.formatMessage({
                        id: 'RELEVANCE.APPLY_DISABLED_WARNING',
                    })}
                </Alert>
            )}
            <ManualPromotedTable
                onSelectEvent={onSelectEvent}
                onMeta={setMeta}
            />
            <ComputedPromotedTable onSelectEvent={onSelectEvent} />
        </div>
    );
}

export default PromotedTable;
